import { get, getPublic, post, put, del } from "../../data/api";
export async function getTools() {
    return await get('tool')
}
export async function getToolOptions(publicId) {
    return await get('tool/options/' + publicId)
}
export async function getToolsWithTerms(s) {
    return await get('tool/search/' + s)
}
export async function getPublicTools(userPublicId) {
    if (userPublicId)
        return await getPublic('public/tools/' + userPublicId)
    else
        return await getPublic('public/tools')
}
export async function getSimilarCategory(publicToolId) {
    return await getPublic('public/tool/similar-category/' + publicToolId)
}
export async function getTool(id, fullPictures = false) {
    return await get('tool/' + id + (fullPictures ? '?fullPictures=true' : ''))
}
export async function getToolCategories() {
    return await get('tool/categories')
}
// Sous-catégories déjà utilisées par le loueur ({ value, name }) pour la liste déroulante éditable.
export async function getToolSubCategories() {
    return await get('tool/subcategories')
}
export async function updateCategory(id, catId) {

    return await put(null, 'tool/' + id + '/category/' + catId)
}
// secondaryCategoryIds : liste complète des catégories secondaires (undefined = inchangées).
export async function updateClassification(id, categoryId, subCategory, secondaryCategoryIds) {
    return await put({ CategoryId: categoryId, SubCategory: subCategory, SecondaryCategoryIds: secondaryCategoryIds }, 'tool/' + id + '/classification')
}
export async function updateToolOptions(id, options) {
    return await put(options, 'tool/' + id + '/options')
}
// Matériels partagés : un même matériel physique publié sous plusieurs annonces (multi-outil…).
// Ses annonces partagent le stock (louer l'une bloque les autres) et cumulent leurs statistiques.
export async function getEquipmentGroups() {
    return await get('tool/equipment-groups')
}
// toolPublicIds : toutes les annonces du matériel (au moins deux).
export async function saveEquipmentGroup(id, name, toolPublicIds) {
    const dto = { Name: name, ToolPublicIds: toolPublicIds };
    return id
        ? await put(dto, 'tool/equipment-groups/' + id)
        : await post(dto, 'tool/equipment-groups')
}
export async function deleteEquipmentGroup(id) {
    return await del('tool/equipment-groups/' + id)
}
export async function ToolStats(publicId, from = null, to = null) {
    const params = [from ? 'from=' + from : null, to ? 'to=' + to : null].filter(Boolean);
    return await get('statistic/tools/' + publicId + (params.length ? '?' + params.join('&') : ''))
}
export async function isAvalaibleTool(data, rentalId) {

    let st = data.dates[0];
    st.setHours(5);

    let en = data.dates[1];
    en.setHours(5);
    let exludeRental = rentalId ? "/" + rentalId : "/" + 0;
    var newHour = data.rentalHour.replace("h", "");
    if (!data.rentalHourEnd)
        data.rentalHourEnd = data.rentalHour;
    var newEndHour = data.rentalHourEnd.replace("h", "");

    var str = data.material.join(",");
    // Le formulaire de location nomme le champ deliveryId : sans lui, la vérification ignorait les battements de livraison
    // et annonçait le créneau libre alors que l'enregistrement le refusait.
    const delivery = data.deliveryId || data.delivery;
    const deliveryQuery = delivery ? "?delivery=" + encodeURIComponent(delivery) : "";
    return await get('tool/avalaible/' + str + "/" + st.toUTCString() + "/" + en.toUTCString() + "/" + newHour + "/" + newEndHour + exludeRental + deliveryQuery)

}

function parseWarehouseIds(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
        return value.map(Number).filter((id) => !Number.isNaN(id) && id > 0);
    }

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.map(Number).filter((id) => !Number.isNaN(id) && id > 0) : [];
    } catch {
        return [];
    }
}

function parsePictureList(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
        return value.filter((picture) => !!picture);
    }

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed.filter((picture) => !!picture) : [];
    } catch {
        return [];
    }
}

export async function createTool(params) {
    let tool = {
        Name: params.toolname,
        Brand: params.brand,
        Model: params.model,
        SubCategory: params.subCategory,
        Accessories: params.accessories,
        PriceDayCents: params.price * 100,
        PriceDayAfterTwoDays: params.price2Days * 100,
        PriceDayAfterSevenDays: params.price7Days * 100,
        DepositCents: params.deposit * 100,
        HourlyPenaltyCents: params.penalities * 100,
        SpecificitiesUseDescription: params.specificities,
        MaterialReturnClause: params.materialReturnClause,
        Base64Picture: params.picture,
        AdditionalPictures: parsePictureList(params.additionalPicturesJson),
        PaidOptions: params.paidOptions,
        Attributes: params.attributes,
        Description: params.description,
        SyncToKiwiiz: params.syncToKiwiiz,
        SyncToAlloVoisins: params.syncToAlloVoisins,
        ToolOptions: params.options,
        Keywords: params.keywords,
        StockTotal: params.stockTotal,
        DeliveryMemo: params.deliveryMemo,
        AlsoAvailableInformation: params.alsoAvailableInformation,
        AdvancedPaymentPercentRequired: params.advancedPaymentPercentRequired,
        SmallDescription: params.smallDescription,
        ShowOnHomePage: params.showOnHomePage,
        WarehouseIds: parseWarehouseIds(params.warehouseIdsJson)
    };

    return await post(tool, 'tool')
}

export async function updateTool(params, id) {
    let tool = {
        Name: params.toolname,
        Brand: params.brand,
        Model: params.model,
        SubCategory: params.subCategory,
        Accessories: params.accessories,
        PriceDayCents: params.price * 100,
        PriceDayAfterTwoDays: params.price2Days * 100,
        PriceDayAfterSevenDays: params.price7Days * 100,
        DepositCents: params.deposit * 100,
        HourlyPenaltyCents: params.penalities * 100,
        SpecificitiesUseDescription: params.specificities,
        MaterialReturnClause: params.materialReturnClause,
        Base64Picture: params.picture,
        AdditionalPictures: parsePictureList(params.additionalPicturesJson),
        PaidOptions: params.paidOptions,
        Attributes: params.attributes,
        Description: params.description,
        SyncToKiwiiz: params.syncToKiwiiz,
        SyncToAlloVoisins: params.syncToAlloVoisins,
        ToolOptions: params.options,
        Keywords: params.keywords,
        StockTotal: params.stockTotal,
        DeliveryMemo: params.deliveryMemo,
        AlsoAvailableInformation: params.alsoAvailableInformation,
        AdvancedPaymentPercentRequired: params.advancedPaymentPercentRequired,
        SmallDescription: params.smallDescription,
        ShowOnHomePage: params.showOnHomePage,
        WarehouseIds: parseWarehouseIds(params.warehouseIdsJson)
    };

    return await put(tool, 'tool/' + id)
}

export async function deleteTool(id) {
    return await del('tool/' + id)
}

export async function syncToKiwiiz(link, toolPublicId) {
    let dto = {
        Link: link,
        ToolPublicId: toolPublicId,

    };

    return await post(dto, 'tool/kiwiiz-sync')
}
export async function unsyncToKiwiiz(toolPublicId) {
    let dto = {
        ToolPublicId: toolPublicId,

    };

    return await post(dto, 'tool/kiwiiz-unsync')
}

export async function getToolAssets(publicId) {
    return await get('tool/' + publicId + '/assets')
}

export async function getToolContractAnnexes(publicId) {
    return await get('tool/' + publicId + '/contract-annexes')
}

export async function updateToolContractAnnexes(publicId, annexes) {
    return await put(annexes, 'tool/' + publicId + '/contract-annexes')
}

export async function upsertToolAsset(publicId, dto) {
    return await post(dto, 'tool/' + publicId + '/assets')
}

export async function deleteToolAsset(publicId, assetType) {
    return await del('tool/' + publicId + '/assets/' + assetType)
}

export async function deleteToolPhoto(publicId, assetId) {
    return await del('tool/' + publicId + '/assets/photo/' + assetId)
}

export async function getPublicToolAssets(publicId) {
    return await getPublic('public/tool-assets/' + publicId)
}

export async function getPublicMaterialAsset(customUrl, assetType) {
    return await getPublic('public/materiel/' + customUrl + '/' + assetType)
}

export async function getToolAssetQrCode(publicId, assetType, baseUrl) {
    const query = encodeURIComponent(baseUrl || "")
    return await get(`tool/${publicId}/assets/${assetType}/qrcode?baseUrl=${query}`)
}

export async function getToolQrCodes(publicId) {
    return await get('tool/' + publicId + '/qrcodes')
}

export async function updateToolQrCode(publicId, qrCodeId, dto) {
    return await put(dto, 'tool/' + publicId + '/qrcodes/' + qrCodeId)
}

export async function deleteToolQrCode(publicId, qrCodeId) {
    return await del('tool/' + publicId + '/qrcodes/' + qrCodeId)
}
